module.exports = __webpack_public_path__ + "img/segniorage.498ee292.svg";